
import clsx from 'clsx'
import {FC} from 'react'
import {
  KTIcon,
  toAbsoluteUrl,
} from '../../../helpers'
import {useSelector} from "react-redux";
import {RootState} from "../../../../app/core/store/store.ts";
import {useIntl} from "react-intl";

const HeaderNotificationsMenu: FC = () => {
  const intl = useIntl()
  const notifications = useSelector((state: RootState) => state.notifications)

  return <div
    className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
    data-kt-menu='true'
  >
    <div
      className='d-flex flex-column bgi-no-repeat rounded-top'
      style={{backgroundImage: `url('${toAbsoluteUrl('media/misc/menu-header-bg.jpg')}')`}}
    >
      <h3 className='text-white fw-bold px-9 mt-10 mb-6'>
        {intl.formatMessage({ id: 'NOTIFICATIONS.NOTIFICATIONS' })} <span className='fs-8 opacity-75 ps-3'>{notifications.notifications.length} {intl.formatMessage({ id: 'NOTIFICATIONS.REPORTS' })}</span>
      </h3>

      <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9'>
        <li className='nav-item'>
          <a
            className='nav-link text-white opacity-75 opacity-state-100 pb-4 active'
            data-bs-toggle='tab'
            href='#kt_topbar_notifications_1'
          >
            {intl.formatMessage({ id: 'NOTIFICATIONS.ALERT' })}
          </a>
        </li>
      </ul>
    </div>

    <div className='tab-content'>
      <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
        <div className='scroll-y mh-325px my-5 px-8'>
          {notifications.notifications.length === 0 ? (
            <div className='d-flex flex-column align-items-center py-10'>
              <KTIcon iconName='notification' className='fs-2x text-muted mb-3' />
              <span className='text-muted fs-7'>{intl.formatMessage({ id: 'ALERTS.NO_RESULTS_FOUND' })}</span>
            </div>
          ) : (
            notifications.notifications.map((notification: any, index: number) => (
              <div key={`notification-${index}`} className='d-flex flex-stack py-4'>
                <div className='d-flex align-items-center'>
                  <div className='symbol symbol-35px me-4'>
                    <span className={clsx('symbol-label', `bg-light-primary`)}>
                      <KTIcon iconName='notification' className='fs-2 text-primary' />
                    </span>
                  </div>

                  <div className='mb-0 me-2'>
                    <span className='fs-6 text-gray-800 fw-bolder'>
                      {notification.title}
                    </span>
                    <div className='text-gray-500 fs-7'>{notification.message}</div>
                  </div>
                </div>

                {notification.time && (
                  <span className='badge badge-light fs-8'>{notification.time}</span>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  </div>
}

export {HeaderNotificationsMenu}
